<app-card-title key="project.steps.system.integrationFlow" />

@if (
  dataDomainResource.isLoading() ||
  integrationTypeDropdownResource.isLoading() ||
  moduleFunctionsResource.isLoading() ||
  moduleNonHrFunctionsResource.isLoading()
) {
  <app-loading />
} @else if (noData()) {
  <div class="flex justify-center items-center py-8">
    <div class="card w-full p-6 text-center">
      <i class="pi pi-info-circle text-4xl mb-4"></i>
      <p class="text-lg">{{ 'project.steps.systemFlow.noSystemRecordings' | transloco }}</p>
    </div>
  </div>
} @else {
  <div class="flex flex-col space-y-3">
    @for (
      officeModuleHrIntegration of officeModuleHrIntegrations();
      track officeModuleHrIntegration.officeId;
      let first = $first
    ) {
      <app-module-integration-panel
        [projectId]="projectId()"
        [isReadOnly]="isReadOnly()"
        [moduleFunctions]="moduleFunctionsResource.value()!"
        [moduleNonHrFunctions]="moduleNonHrFunctionsResource.value()!"
        [isFirst]="first"
        [officeId]="officeModuleHrIntegration.officeId"
        [officeName]="officeModuleHrIntegration.officeName"
        [moduleHrIntegrationSystemRecordings]="
          officeModuleHrIntegration.moduleHrIntegrationSystemRecordings
        "
        [moduleNonHrIntegrationSystemRecordings]="
          moduleNonHrIntegrationSystemRecordings(officeModuleHrIntegration.officeId)
        "
        [dataDomainOptions]="dataDomainOptions()"
        [integrationTypeOptions]="integrationTypeOptions()"
      ></app-module-integration-panel>
    }
  </div>
}
